import React from 'react';
import { Link } from 'gatsby';
import BlogPosts from 'containers/BlogPosts';
import PropTypes from 'prop-types';

function RecentPodcasts({ podcasts }) {
  return (
    <BlogPosts
      title={<>Learn From the Experts</>}
      description={
        <>
          Follow our podcast and find out what it takes to be successful as a
          landlord. We have a variety of guests from all areas of the property
          world including licensing, property management, HMO experts and more.
          You can listen on Spotify, Amazon or Apple and other major podcasting
          sites. We want to provide you with all of the knowledge you need for
          success! <Link to="/podcast/">Start Listening</Link>
        </>
      }
      blogPosts={podcasts}
      isPodcasts={true}
      inversePostCards={false}
    />
  );
}

RecentPodcasts.propTypes = {
  podcasts: PropTypes.array,
};

export default RecentPodcasts;
